/**
 * Class representing a user.
 * @author Alizée Grand
 * @version 1.0
 * @creation 16/03/2022
 * @last_update 16/03/2022
 **/
export class User {

    /**
     * User's identifier allowing to identify him precisely.
     * @type {string}
     * @private
     */
    private _id: string;

    /**
     * Token of the user guaranteeing his authentication to the API.
     * @type {string}
     * @private
     */
    private _token: string;

    /**
     * Object used to model a user.
     * @param {string} id User's identifier allowing to identify him precisely.
     * @param {string} token Token of the user guaranteeing his authentication to the API.
     */
    constructor(id: string, token: string) {
        this._id = id;
        this._token = token;
    }

    /**
     * Get the token of the user guaranteeing his authentication to the API.
     * @return {string}
     */
    get token(): string {
        return this._token;
    }

    /**
     * Set the token of the user guaranteeing his authentication to the API.
     * @param {string} value New token.
     */
    set token(value: string) {
        this._token = value;
    }

    /**
     * Get the user's identifier allowing to identify him precisely.
     * @return {string}
     */
    get id(): string {
        return this._id;
    }

    /**
     * Set the user's identifier allowing to identify him precisely.
     * @param {string} value New identifier.
     */
    set id(value: string) {
        this._id = value;
    }

    /**
     * Checks if the user is correct.
     * @return {boolean} True if the user is correct.
     */
    public isCorrect(): boolean {
        return (
            this.id !== "" &&
            this.token !== ""
        );
    }

    /**
     * Takes an object in parameter and returns a user if possible.
     * @param userToRemap Object to cast.
     * @return User if the attributes of the object correspond to a user, otherwise null.
     */
    public static remapUser(userToRemap: any): User | null {
        let user: User | null = null
        if(userToRemap._id && userToRemap._token) {
            const tempUser = new User(userToRemap._id, userToRemap._token);
            if(tempUser.isCorrect()) {
                user = tempUser;
            }
        }
        return user;
    }
}

